// HoverIcon.js
import CustomIcon from "../../data/IconCompo";
import "../../styles/main.scss";

export default function HoverIcon({ icon, iconHover, isParentHovered }) {
  return (
    <CustomIcon iconName={isParentHovered ? (iconHover || icon) : icon} />
  );
}
